<template>
    <MainLayout />
</template>

<script>
import {
    mapActions,
} from 'vuex'
import MainLayout from '@/layout/Main.vue'

export default {
    name: 'App',
    components: {
        MainLayout,
    },
    metaInfo () {
        return {
            titleTemplate: this.$t('meta.general.titleTemplate'),
            title: this.$t('meta.general.title'),
            meta: [
                {
                    name: 'description',
                    content: this.$t('meta.general.description'),
                },
            ],
            htmlAttrs: {
                lang: this.$i18n.locale,
            },
        }
    },
    created () {
        this.startup()
    },
    methods: {
        ...mapActions({
            startup: `system/startup`,
        }),
    },
}
</script>
